import { Box, styled } from "@mui/material";
import { Button, createShouldForwardPropBlockList, SearchBox } from "@pmag/ui-components";

export const ContainerBox = styled(Box)(({ theme }) => ({
    flex: 1,
    marginBottom: theme.spacing(8),
}));

export const SearchBoxContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    flex: 1,
    backgroundColor: theme.palette.core.grey._20,
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadow.boxShadow.sm,

    [theme.breakpoints.up("md")]: {
        padding: theme.spacing(6),
    },
}));

export const TopContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),

    [theme.breakpoints.up("md")]: {
        marginBottom: theme.spacing(6),
    },
}));

export const InputBox = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(3),
}));

export const StyledSearchBoxContainer = styled(Box)(() => ({
    flex: 1,
}));

export const StyledSearchBox = styled(SearchBox, {
    shouldForwardProp: createShouldForwardPropBlockList(["error"]),
})<{ error: boolean }>(({ theme, error }) => ({
    color: theme.palette.core.grey._70,
    borderColor: error ? theme.palette.red._50 : theme.palette.core.grey._30,
    fontSize: "16px" /* prevents mobile Safari from auto scale */,
}));

export const MediumSearchButton = styled(Button)(({ theme }) => ({
    display: "none",
    [theme.breakpoints.up("sm")]: {
        display: "flex",
    },
}));

export const MediumInfoButton = styled(Button)(({ theme }) => ({
    display: "none",
    padding: 0,

    [theme.breakpoints.up("sm")]: {
        display: "flex",
    },
}));

export const SmallBottomBox = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),

    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
}));

export const SmallInfoButton = styled(Button)(({ theme }) => ({
    paddingRight: 0,
}));

export const InfoBox = styled(Box)(({ theme }) => ({
    position: "relative",
    flex: 1,
    backgroundColor: theme.palette.core.grey._10,
    padding: theme.spacing(6),
    borderWidth: 1,
    borderColor: theme.palette.core.grey._30,
    borderStyle: "solid",
    borderRadius: theme.shape.borderRadius,
    gap: theme.spacing(2),
    boxShadow: theme.shadow.boxShadow.lg,
}));

export const CloseInfoButton = styled(Button)(() => ({
    position: "absolute",
    top: 0,
    right: 0,
}));

export const LoadingBox = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#87878770",
}));
